export default __webpack_public_path__ + "static/media/OpenSans.afa30f4d.woff2";